import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

export class RenovarService {

    static httpPostRenovar(form) {
        return SharedService.httpPost(ApplicationConstants.postRenovarUrl, form).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                    //throw "Error";
                }
                else {
                   return response.body;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/renovar/services/renovarService.js